import {
  type AlertBannerColorTheme,
  type DataThemeOptions,
} from "@saviynt/design-system";

// Shorthand for the design-system color tokens to reduce code clutter
export const TOKENS = {
  // Foreground
  CF_PRI_BLD: "--color-foreground-primary-bold",
  CF_PRI_MED: "--color-foreground-primary-medium",
  CF_SEC_BLD: "--color-foreground-secondary-bold",
  CF_SEC_MED: "--color-foreground-secondary-medium",
  CF_SEC_STL: "--color-foreground-secondary-subtle",
  CF_NEU_BLD: "--color-foreground-neutral-bold",
  CF_NEU_MED: "--color-foreground-neutral-medium",
  CF_NEU_STL: "--color-foreground-neutral-subtle",
  CF_NEU_INV: "--color-foreground-neutral-inverse",
  CF_CRT_BLD: "--color-foreground-critical-bold",
  CF_CRT_MED: "--color-foreground-critical-medium",
  CF_WRN_BLD: "--color-foreground-warning-bold",
  CF_WRN_STL: "--color-foreground-warning-subtle",
  CF_SUC_MED: "--color-foreground-success-medium",
  CF_SUC_BLD: "--color-foreground-success-bold",
  CF_INF_BLD: "--color-foreground-info-bold",
  CF_INF_MED: "--color-foreground-info-medium",
  CF_INF_STL: "--color-foreground-info-subtle",
  CF_SAV_MED: "--color-foreground-savi-medium",
  // Background
  CB_INF_STL: "--color-background-info-subtle",
} as const;

export const SYSTEM_DATA_THEMES = {
  LIGHT: "light" as const satisfies DataThemeOptions,
  DARK: "dark" as const satisfies DataThemeOptions,
} as const;

export const ALERT_BANNER_TYPES = {
  CRITICAL: "Critical" as const satisfies AlertBannerColorTheme,
  WARNING: "Warning" as const satisfies AlertBannerColorTheme,
  SUCCESS: "Success" as const satisfies AlertBannerColorTheme,
  INFO: "Information" as const satisfies AlertBannerColorTheme,
} as const;
